/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
import React from 'react';

const Quality = () => {
  return <svg className="store-svg-quality" viewBox="0 0 1024 1024">
    <path d="M353.621 660.821h128.341v21.845h-128.341v-21.845z"/>
    <path d="M353.621 554.325h128.341v21.845h-128.341v-21.845z"/>
    <path d="M353.621 447.829h255.317v21.845h-255.317v-21.845z"/>
    <path d="M353.621 341.333h255.317v21.845h-255.317v-21.845z"/>
    <path d="M682.667 225.28h-405.504c-17.749 0-31.403 24.576-31.403 40.96v490.155c0 17.749 12.288 21.845 31.403 21.845h203.435v-20.48h-203.435c-6.827 0-9.557 5.461-9.557-1.365v-490.155c0-6.827 2.731-20.48 9.557-20.48h405.504c6.827 0 12.288 15.019 12.288 20.48v192.512h21.845v-192.512c-1.365-16.384-17.749-40.96-34.133-40.96z"/>
    <path d="M633.515 750.933c-25.941 0-50.517-9.557-68.267-27.307-36.864-36.864-36.864-98.304 0-135.168 36.864-36.864 98.304-36.864 135.168 0v0 0c17.749 17.749 27.307 42.325 27.307 68.267s-9.557 50.517-27.307 68.267c-16.384 16.384-40.96 25.941-66.901 25.941zM633.515 581.632c-19.115 0-38.229 6.827-51.883 21.845-28.672 28.672-28.672 76.459 0 105.131 13.653 13.653 32.768 21.845 51.883 21.845 19.115 0 38.229-6.827 51.883-21.845 13.653-15.019 21.845-32.768 21.845-51.883 0-19.115-6.827-38.229-21.845-51.883v0c-13.653-16.384-32.768-23.211-51.883-23.211z"/>
    <path d="M686.635 723.936l15.446-15.446 75.303 75.303-15.446 15.446-75.303-75.303z"/>
    <path d="M512 34.133c263.509 0 477.867 214.357 477.867 477.867s-214.357 477.867-477.867 477.867-477.867-214.357-477.867-477.867 214.357-477.867 477.867-477.867M512 6.827c-278.528 0-505.173 226.645-505.173 505.173s226.645 505.173 505.173 505.173 505.173-226.645 505.173-505.173-226.645-505.173-505.173-505.173v0z"/>
  </svg>
};

export default Quality;



// WEBPACK FOOTER //
// ./src/svgs/quality.js